// extracted by mini-css-extract-plugin
export var dayLabel = "_m8-0";
export var pickerDisabled = "_m8-1";